// const server = "http://localhost";
// const port = 9120;
// const domain = "localhost";
const server = "http://api.lanuevatendencia.com";
const port = 80;
const domain = "lanuevatendencia.com";
export { server, port, domain };
